import { render } from "./SitemapRow.vue?vue&type=template&id=36853f9b&scoped=true"
import script from "./SitemapRow.vue?vue&type=script&lang=js"
export * from "./SitemapRow.vue?vue&type=script&lang=js"

import "./SitemapRow.vue?vue&type=style&index=0&id=36853f9b&lang=scss&scoped=true"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36853f9b"]])

export default __exports__